import { useEffect, useMemo, useState } from 'react';
import {
  filterMlModelsBySubstring,
  filterModelsByState,
  mlModelsSorter,
  parseMlModels,
  stringifyModels,
} from 'components/TeamOverview/components/AiComputeTransactionsCard/utilities';
import {
  ALL_TAB,
  NO_FILTER_VALUE,
} from 'components/TeamOverview/components/AiComputeTransactionsCard/constants';
import { getMLModels } from 'services/resources/commonResources';
import { useSnackbar } from 'utilities/hooks/useSnackbar/useSnackbar';
import { FAIL_GET_SLIDE_ML_DATA } from 'constants/errorMessages';

export const useMlModels = (
  team,
  tabValue = ALL_TAB,
  filter = '',
  modelFilter = NO_FILTER_VALUE,
) => {
  const [mlModels, setMlModels] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [stringifedModels, setStringifiedModels] = useState(null);
  const { showError } = useSnackbar();

  useEffect(() => {
    setIsLoading(true);
    getMLModels()
      .then((res) => {
        const filteredByTeamModels = res.filter(
          (model) => model.team.uuid === team.uuid,
        );
        const parsedMlModels = parseMlModels(filteredByTeamModels);
        const sortedMlModels = parsedMlModels.sort(mlModelsSorter);
        setMlModels(sortedMlModels);
        setStringifiedModels(stringifyModels(sortedMlModels));
        setIsLoading(false);
      })
      .catch(() => showError(FAIL_GET_SLIDE_ML_DATA));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredModels = useMemo(() => {
    const filteredBySubstringModels = filter
      ? filterMlModelsBySubstring(stringifedModels, filter)
      : mlModels;
    const filteredByStateModels = filterModelsByState(
      filteredBySubstringModels,
      tabValue,
    );

    return filteredByStateModels;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabValue, filter, modelFilter, mlModels]);

  const filteredByNameModels = useMemo(
    () =>
      modelFilter === NO_FILTER_VALUE
        ? filteredModels
        : filteredModels.filter((model) => model.aiModel === modelFilter),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filteredModels, modelFilter],
  );

  return {
    isLoading,
    data: filteredByNameModels,
    notFilteredByNameModels: filteredModels,
  };
};
